import { useEffect } from 'react'


const events = [ 'mousedown', 'touchstart' ]

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    if (!handler) {
      return
    }

    const listener = (event) => {
      if (!ref.current || !handler || ref.current.contains(event.target)) {
        return
      }

      handler(event)
    }

    events.forEach((event) => document.addEventListener(event, listener))

    return () => {
      events.forEach((event) => document.removeEventListener(event, listener))
    }
  }, [ handler ])
}


export default useOnClickOutside
